import { AxiosInstance } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v0/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v0/timeline-containers';

export class TimelineServiceV0 implements types.Handlers {
  private serviceEndpoint = '/timelinecontainers';

  constructor(private axios: AxiosInstance) {}

  async updateTimelineContainer({
    path,
    body,
  }: types.UpdateTimelineContainerParameters): Promise<types.UpdateTimelineContainerResponse> {
    return (await this.axios.put(`${this.serviceEndpoint}/${path.containerId}`, body)).data;
  }
  async deleteTimelineContainer(
    params: types.DeleteTimelineContainerParameters,
  ): Promise<common.MessageOnlyResponse> {
    const { data } = await this.axios.delete<common.MessageOnlyResponse>(
      `${this.serviceEndpoint}/${params.path.containerId}`,
    );
    return data;
  }
  async setScanTimelineContainer({
    path,
    body,
  }: types.SetScanTimelineContainerParameters): Promise<types.UpdateTimelineContainerResponse> {
    return (await this.axios.put(`${this.serviceEndpoint}/${path.containerId}/scans`, body)).data;
  }
  async setTiledModelTimelineContainer({
    path,
    body,
  }: types.SetTiledModelTimelineContainerParameters): Promise<types.UpdateTimelineContainerResponse> {
    return (await this.axios.put(`${this.serviceEndpoint}/${path.containerId}/tiled-models`, body))
      .data;
  }
  async setOrthotileTimelineContainer({
    path,
    body,
  }: types.SetOrthotileTimelineContainerParameters): Promise<types.UpdateTimelineContainerResponse> {
    return (await this.axios.put(`${this.serviceEndpoint}/${path.containerId}/orthotiles`, body))
      .data;
  }
  async updateAssociatedPointCloud({
    path,
    body,
  }: types.UpdateAssociatedPointCloudParameters): Promise<types.UpdateTimelineContainerResponse> {
    return (await this.axios.put(`${this.serviceEndpoint}/${path.timelineId}/point-clouds`, body))
      .data;
  }
}
